import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Card, Button, ButtonGroup, Row, Col, Table } from 'react-bootstrap';
import { MdAddCircle, MdDelete, MdOutlineGridView, MdReorder, MdViewList } from "react-icons/md";
import { FaArrowAltCircleRight, FaChevronDown, FaChevronUp, FaList } from "react-icons/fa";
import ProjectAPIs from "../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import ApiResponseHandler from "../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { format } from 'date-fns';
import './ProjectsTable.css';

function ProjectsTable({ projectList, getProjectList }) {
    const navigate = useNavigate();
    const headerColumns = ["CIS ID", "Title", "Applicant", "Start", "End", "Status", "Description", "View"];
    const [sending, setSending] = useState(false);
    const [expandedRows, setExpandedRows] = useState({});
    const [viewMode, setViewMode] = useState("grid"); // "grid" | "list"

    const toggleDescription = (id) => {
        setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const deleteProject = (projectID) => {
        setSending(true);
        ProjectAPIs.DeleteProject(projectID)
            .then((response) => {
                if (response.status === 200) {
                    getProjectList('');
                    setSending(false);
                }
            })
            .catch((err) => {
                setSending(false);
                ApiResponseHandler(err.response, navigate);
            });
    };

    const handleClick = (projectID) => navigate('/project/' + projectID);
    const handleDelete = (projectID) => {
        if (window.confirm('Are you sure you want to delete this project? This cannot be undone.')) {
            deleteProject(projectID);
        }
    };

    return (
        // <Card className="projects-table-card">
        //     <Card.Body>
        //         {projectList.length === 0 ? (
        //             <div className="projects-empty-message">No projects found.</div>
        //         ) : (
        //             <div className="projects-table-responsive">
        //                 <Table hover striped responsive className="projects-table">
        //                     <thead>
        //                         <tr>
        //                             {headerColumns.map((col, idx) => <th key={idx}>{col}</th>)}
        //                         </tr>
        //                     </thead>
        //                     <tbody>
        //                         {projectList.map(project => {
        //                             const isExpanded = expandedRows[project.id] || false;
        //                             const descriptionShort = project.building_description?.length > 50
        //                                 ? project.building_description.slice(0, 50) + '...'
        //                                 : project.building_description;

        //                             return (
        //                                 <tr key={project.id} className="project-row">
        //                                     <td data-label="CIS ID">{project.cis_id}</td>
        //                                     <td data-label="Title">{project.name}</td>
        //                                     <td data-label="Applicant">{project.applicant}</td>
        //                                     <td data-label="Start">{format(new Date(project.start_date), 'dd-MMM-yyyy')}</td>
        //                                     <td data-label="End">{format(new Date(project.end_date), 'dd-MMM-yyyy')}</td>
        //                                     <td data-label="Completed">
        //                                         {/* <span className={`projects-completed-badge ${project.completed ? 'yes' : 'no'}`}>
        //                                             {project.completed ? 'Yes' : 'No'}
        //                                         </span> */}
        //                                         <span className={`status-badge ${project.completed ? 'complete' : 'active'}`}>
        //                                             {project.completed ? "Completed" : "Active"}
        //                                         </span>
        //                                     </td>
        //                                     <td data-label="Description">
                                                // <div className="description-wrapper">
                                                //     {isExpanded ? project.building_description : descriptionShort}
                                                //     {project.building_description?.length > 50 && (
                                                //         <span
                                                //             className="description-toggle"
                                                //             onClick={() => toggleDescription(project.id)}
                                                //         >
                                                //             {isExpanded ? " Read Less" : " Read More"}
                                                //         </span>
                                                //     )}
                                                // </div>
        //                                     </td>
        //                                     {/* <td>
        //                                         <button
        //                                             disabled={sending}
        //                                             className="projects-delete-btn"
        //                                             onClick={() => handleDelete(project.id)}
        //                                         ><MdDelete /></button>
        //                                     </td> */}
        //                                     <td>
        //                                         <button
        //                                             disabled={sending}
        //                                             className="projects-view-btn"
        //                                             onClick={() => handleClick(project.id)}
        //                                         ><FaArrowAltCircleRight /></button>
        //                                     </td>
        //                                 </tr>
        //                             )
        //                         })}
        //                     </tbody>
        //                 </Table>
        //             </div>
        //         )}
        //     </Card.Body>
        // </Card>

        // <div>
        //     {projectList.map((project) => {
        //         return(

        //             <div key={project.id} className="projects-table-card">
        //                 <div align='end'>
        //                     <span className={`status-badge ${project.completed ? 'complete' : 'active'}`}>
        //                         {project.completed ? "Completed" : "Active"}
        //                     </span>
        //                 </div>
        //                 <div>
        //                     <h3>{project.name}</h3> 
        //                     <span>{project.cis_id ?? 'No CIS ID'} - {(project.applicant === '' || project.applicant === null) ? 'No promotor' : project.applicant}</span>
        //                 </div>

        //             </div>
        //         )
        //     })}
        // </div>






            <div>

                {/* VIEW TOGGLE */}
                <div className="desktop-only">
                <div className="project-header-actions mb-2 ">
                        <button onClick={() => setViewMode("grid")} className={viewMode === 'grid' ? 'edit-btn' : 'cancel-btn'}>
                        <MdOutlineGridView/>
                        </button>

                        <button onClick={() => setViewMode("list")} className={viewMode === 'list' ? 'edit-btn' : 'cancel-btn'}>
                        <FaList/>
                        </button>
                </div>
                </div>

                {projectList.length === 0 ? (
                    <div className="projects-empty-message">No projects found.</div>
                ) : (
                    <div className={`projects-card-container ${viewMode}`}>
                        {projectList.map(project => {
                            const isExpanded = expandedRows[project.id] || false;

                            const descriptionShort =
                                project.building_description?.length > 30
                                    ? project.building_description.slice(0, 30) + "..."
                                    : project.building_description;

                            return (
                                // <div key={project.id} className="project-card">

                                //     {/* HEADER (HIGH PRIORITY) */}
                                    // <div className="project-card-header">
                                    //     <div className="project-title">
                                    //         {project.name}
                                    //     </div>

                                        // <span className={`status-badge ${project.completed ? "complete" : "active"}`}>
                                        //     {project.completed ? "Completed" : "Active"}
                                        // </span>
                                    // </div>
                                    

                                //     {/* IMPORTANT INFO */}
                                //     <div className="project-meta">
                                //         <div><strong>CIS:</strong> {project.cis_id}</div>
                                //         <div><strong>Applicant:</strong> {project.applicant}</div>
                                //     </div>

                                //     {/* DATES */}
                                //     <div className="project-dates">
                                //         <div>
                                //             <strong>Start:</strong>{" "}
                                //             {format(new Date(project.start_date), "dd-MMM-yyyy")}
                                //         </div>
                                //         <div>
                                //             <strong>End:</strong>{" "}
                                //             {format(new Date(project.end_date), "dd-MMM-yyyy")}
                                //         </div>
                                //     </div>

                                //     {/* DESCRIPTION */}
                                //     {/* <div className="project-description">
                                //         {isExpanded ? project.building_description : descriptionShort}

                                //         {project.building_description?.length > 80 && (
                                //             <span
                                //                 className="description-toggle"
                                //                 onClick={() => toggleDescription(project.id)}
                                //             >
                                //                 {isExpanded ? " Read Less" : " Read More"}
                                //             </span>
                                //         )}
                                //     </div> */}
                                //     <div className="description-wrapper">
                                //         {isExpanded ? project.building_description : descriptionShort}
                                //         {project.building_description?.length > 50 && (
                                //             <span
                                //                 className="description-toggle"
                                //                 onClick={() => toggleDescription(project.id)}
                                //             >
                                //                 {isExpanded ? " Read Less" : " Read More"}
                                //             </span>
                                //         )}
                                //     </div>

                                //     {/* ACTION */}
                                //     <div className="project-header-actions project-actions">
                                        // <Button
                                        //     disabled={sending}
                                        //     className="edit-btn"
                                        //     onClick={() => handleClick(project.id)}
                                        // >
                                        //     View <FaArrowAltCircleRight />
                                        // </Button>
                                //     </div>
                                // </div>
                                <div key={project.id} className="project-section project-card">
                                    <div className="project-section-header">
                                        <h5 className="section-title">{project.name}</h5>
                                        <div>
                                            <span className={`status-badge ${project.completed ? "complete" : "active"}`}>
                                                {project.completed ? "Completed" : "Active"}
                                            </span>
                                        </div>
                                    </div>

                                    <div >
                                        <div className="project-header-left">
                                            <div className="project-meta">

                                                <div className="meta-item">
                                                        <span className="label">CIS ID:</span>
                                                        <span>{project.cis_id}</span>
                                                </div>
                                                <div className="meta-item">
                                                        <span className="label">Promotor:</span>
                                                        <span>{project.applicant}</span>
                                                </div>

                                                <div className="meta-item">
                                                        <span className="label">Start:</span>
                                                        <span>{project.start_date ? format(new Date(project.start_date), "dd-MMM-yyyy") : 'Not saved'}</span>
                                                </div>

                                                <div className="meta-item">
                                                        <span className="label">End:</span>
                                                        <span>{project.end_date ? format(new Date(project.end_date), "dd-MMM-yyyy") : 'Not saved'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    
                                        
                                        
                                    </div>

                                    {/* <div className="description-wrapper">
                                        {isExpanded ? project.building_description : descriptionShort}
                                        {project.building_description?.length > 30 && (
                                            <span
                                                className="description-toggle"
                                                onClick={() => toggleDescription(project.id)}
                                            >
                                                {isExpanded ? " Read Less" : " Read More"}
                                            </span>
                                        )}
                                    </div> */}

                                        <div style={{marginTop: 'auto'}} className="project-header-actions">
                                            <button
                                            disabled={sending}
                                            className="edit-btn"
                                            onClick={() => handleClick(project.id)}
                                        >
                                            View <FaArrowAltCircleRight />
                                        </button>
                                        </div>
                                        
                                        
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
    );
}

export default ProjectsTable;